<template>
  <div class="expire-time-wrapper">
    <span class="color--pinkred-110">{{ minutes | twoDigits }}:{{ seconds | twoDigits }}</span>
  </div>
</template>

<script>
export default {
  props: {
    expireDate: {
      type: Date,
      default: null,
    },
  },
  data() {
    return {
      expireTime: null,
      minutes: null,
      seconds: null,
      expireIn: null,
    }
  },
  watch: {
    expireIn(v) {
      if (v < 1) {
        this.$emit('emitTimeOver')
      }
    },
  },
  created() {
    this.expireTime = this.expireDate.getTime()
    this.time()
  },
  methods: {
    time() {
      const now = new Date().getTime()
      this.expireIn = Math.floor((this.expireTime - now) / 1000)

      this.minutes = Math.floor(this.expireIn / 60)
      this.seconds = this.expireIn % 60
      if (this.expireIn > 0) {
        setTimeout(this.time, 1000)
      }
    },
  },
  filters: {
    twoDigits(value) {
      const num = Number(value)
      return num < 10 ? '0' + num : num
    },
  },
}
</script>

<style lang="scss" scoped>
.expire-time-wrapper {
  text-align: left;
}
</style>
